import React, { useState, useEffect } from "react";
import axios from "axios";

const BulkWhatsApp = () => {
  const [numbers, setNumbers] = useState("");
  const [message, setMessage] = useState("");

  // Fetch all mobile numbers when component loads
  useEffect(() => {
    const fetchNumbers = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/user-contacts`
        );
        const numberList = response.data.map((user) => user.mobile).join(",");
        setNumbers(numberList);
      } catch (error) {
        console.error("Error fetching numbers:", error);
      }
    };

    fetchNumbers();
  }, []);

  const sendWhatsApp = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/send-whatsapp`,
        {
          numbers: numbers.split(",").map((num) => num.trim()),
          message,
        }
      );

      alert(response.data.message);
    } catch (error) {
      console.error("Error sending WhatsApp messages:", error);
      alert("Failed to send WhatsApp messages");
    }
  };

  return (
    <div className="row mail-bx">
      <form>
        <div className="mb-1 mb-3">
          <textarea
            className="form-control"
            placeholder="Mobile Numbers (Auto-filled)"
            value={numbers}
            readOnly
          />
        </div>
        <div className="mb-1 mb-3">
          <textarea
            className="form-control"
            placeholder="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>
        <div>
          <button className="btn btn-primary w-100 mt-3" onClick={sendWhatsApp}>
            Send Messages
          </button>
        </div>
      </form>
    </div>
  );
};

export default BulkWhatsApp;
